var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4Month(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#E365B1",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E365B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 11.5C25.7722 11.5 27.6578 11.5 28.8294 12.7448C30.001 13.9896 30.001 15.9931 30.001 20C30.001 24.0069 30.001 26.0104 28.8294 27.2552C27.6578 28.5 25.7722 28.5 22.001 28.5L18.001 28.5C14.2297 28.5 12.3441 28.5 11.1725 27.2552C10.001 26.0104 10.001 24.0069 10.001 20C10.001 15.9931 10.001 13.9896 11.1726 12.7448C12.3441 11.5 14.2297 11.5 18.001 11.5L22.001 11.5Z",
    stroke: "#E365B1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.993 22.712H16.889V24.5H15.677V22.712H11.777V21.86L15.953 16.388H16.889V21.656H17.993V22.712ZM13.133 21.656H15.677V18.224L13.133 21.656ZM20.2388 24.5H19.0268V18.14H20.1548V19.196C20.5868 18.464 21.2708 18.02 22.1468 18.02C23.0828 18.02 23.7908 18.5 24.0788 19.34C24.5228 18.524 25.2548 18.02 26.2268 18.02C27.5348 18.02 28.3748 18.872 28.3748 20.384V24.5H27.1628V20.768C27.1628 19.712 26.6948 19.088 25.8068 19.088C24.9788 19.088 24.3068 19.784 24.3068 20.852V24.5H23.0948V20.768C23.0948 19.712 22.6268 19.088 21.7388 19.088C20.8988 19.088 20.2388 19.784 20.2388 20.852V24.5Z",
    fill: "#E365B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Month);
export default __webpack_public_path__ + "static/media/4month.b4c0b20eaa8610507f3d13a2dd0a8947.svg";
export { ForwardRef as ReactComponent };